<template>
<!DOCTYPE html>
  <div class="task-list panel list-panel">
    <el-card class="box-card">
      <el-input
        prefix-icon="el-icon-search"
        v-model="search"
        style="padding-bottom: 5px"
        placeholder="Search project"/>
      <el-table
        :data="filteredProjects"
        stripe
        height=inherit
        class="table-projects">
        <el-table-column
          fixed
          prop=""
          label="Project"
          width="420">
          <template slot-scope="scope">
            <el-button plain class="project-list-item list-item"
                       @click="gotoProject(scope.row)">
              <div class="list-item-btn">
                <client-code v-if="!scope.row.client_icon_url" :code="scope.row.client_code" :seed="scope.row.client_name" />
                <img v-if="scope.row.client_icon_url" :src="scope.row.client_icon_url" class="client-code"/>
                <div class="title"><b>{{ scope.row.name }}</b></div>
              </div>
            </el-button>
          </template>
        </el-table-column>
        <el-table-column
          prop=""
          fixed
          label="Due Date"
          width="120">
          <template slot-scope="scope">
            <span>{{ getProjectDueDate(scope.row.due_date) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          fixed
          prop=""
          label="Days Left"
          align="center"
          width="150">
          <template slot-scope="scope">
            <el-tag size="medium" type='success' v-if="dayDiffCurrentDate(scope.row.due_date) > 1" >{{ dayDiffCurrentDate(scope.row.due_date) }}</el-tag>
            <el-tag size="medium" type='danger' v-else-if="dayDiffCurrentDate(scope.row.due_date) < 1">{{ dayDiffCurrentDate(scope.row.due_date)}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          v-for="(user, id) in activeUsers"
          :key="id"
          prop=""
          align="center"
          v-bind:label=user.first_name>
          <template slot-scope="project" v-if="isInTheProject(project, user.id)">
            <i class="el-icon-circle-check middle" style="font-size:20px"></i>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>


<script>
  import { mixin as LogTimes } from '../../mixins/LogTimes'
  export default {
    mixins: [LogTimes]  ,
    name: 'project-list-table',
    props:{
      projects: {
        default: []
      },
      isProspect: {
        default: false
      },
      activeUsers:{
        default: []
      }
    },
    data() {
      return {
        search: "",
        filteredProjects: []
      }
    },
    watch: {
      search: function() {
        this.debouncedFilterProj();
      },
      isProspect: function() {
        this.doProjFilter();
      },
      projects () {
        // When the Project list changes (e.g. due to a websocket update), regenerate the project list
        this.doProjFilter();
      }
    },
    methods: {
      isPromoted: ( {promoted_at} ) => promoted_at === null,
      isCurrent: ( {promoted_at} ) => (promoted_at !== null),
      dayDiffCurrentDate(date){
        if(!date){
          return
        }
        this.date = new Date(date);
        let currDateInMs = Date.now();
        let dayInMs = 1000*60*60*24;
        let dateInMs = this.date.getTime();
        let diffInMs = (dateInMs - currDateInMs)

        return (diffInMs / dayInMs).toFixed(2) //1.50 day or -3.00 day
      },
      getProjectDueDate (date) {
        return date ? this.dateTimeToDate(date) : ''
      },
      doProjFilter () {
        if(this.isProspect){
          this.filteredProjects = this.projects.filter((k) => k.name.toLowerCase().includes(this.search.toLowerCase()))
                                               .filter(this.isPromoted)  
        }else{
          this.filteredProjects = this.projects.filter((k) => k.name.toLowerCase().includes(this.search.toLowerCase()))
                                               .filter(this.isCurrent)
        }
      },
      isInTheProject (proj, userId) {
        const projUsers = proj.row.associated_users
        const isUserInProj = projUsers.includes(userId)
        return isUserInProj
      },
      gotoProject (project) {
        this.$router.push({name: 'project', params: { project_id: project.id }})
      },
      // as long as it continues to be invoked, it will not be triggered
      debounce (func, interval) {
        let timeout;
        return function () {
          const context = this, args = arguments;
          const later = function () {
            timeout = null;
            func.apply(context, args);
          };
          clearTimeout(timeout);
          timeout = setTimeout(later, interval || 200);
        }
      }
    },
    created () {
      this.debouncedFilterProj = this.debounce(this.doProjFilter, 300);
      this.doProjFilter();
    }
  }
</script>

<style lang="less" scoped>
.table-projects {
  max-height: calc(~"100vh - 240px");
  min-height: calc(~"100vh - 240px");
  width: 100%;
}
.box-card {
  padding: 10px;
  background: white;
}
.middle {
  font-size: 40px;
}
</style>

